export const randomFactOfTheDayTopics = [
    "Space",
    "Astronomy",
    "Planets",
    "Stars",
    "Black Holes",
    "Galaxies",
    "The Moon",
    "The Sun",
    "Earth",
    "Volcanoes",
    "Earthquakes",
    "Weather",
    "Climate",
    "Oceans",
    "Rivers",
    "Mountains",
    "Deserts",
    "Forests",
    "Waterfalls",
    "Caves",
    "Dinosaurs",
    "Prehistoric Animals",
    "Mammals",
    "Birds",
    "Snakes",
    "Reptiles",
    "Amphibians",
    "Fish",
    "Insects",
    "Spiders",
    "Marine Life",
    "Dogs",
    "Cats",
    "Elephants",
    "Whales",
    "Sharks",
    "Octopuses",
    "Bees",
    "Butterflies",
    "Human Body",
    "Brain",
    "DNA",
    "Medicine",
    "Health",
    "Nutrition",
    "Exercise",
    "Sleep",
    "Psychology",
    "Artificial Intelligence",
    "Robotics",
    "Computers",
    "Programming",
    "Cybersecurity",
    "Internet",
    "Social Media",
    "Video Games",
    "Virtual Reality",
    "Quantum Computing",
    "Mathematics",
    "Physics",
    "Chemistry",
    "Biology",
    "History",
    "Ancient Civilizations",
    "Egypt",
    "Rome",
    "Greece",
    "Middle Ages",
    "World War I",
    "World War II",
    "Explorers",
    "Pirates",
    "Castles",
    "Famous People",
    "Inventors",
    "Scientists",
    "Artists",
    "Musicians",
    "Authors",
    "Movies",
    "Books",
    "Music",
    "Food",
    "Coffee",
    "Chocolate",
    "Pizza",
    "Fruits",
    "Vegetables",
    "Cooking",
    "Languages",
    "Countries",
    "Capital Cities",
    "Flags",
    "Cultures",
    "Traditions",
    "Festivals",
    "Sports",
    "Olympics",
    "Football",
    "Basketball",
    "Tennis",
    "Cars",
    "Airplanes",
    "Trains",
    "Ships"
];